// extracted by mini-css-extract-plugin
export default {"printFile":"PrintPage_printFile__zx75T","pageContent":"PrintPage_pageContent__Nvev2"};